import { render, staticRenderFns } from "./dialog_peizhiEdit.vue?vue&type=template&id=9f66e1a6&scoped=true&"
import script from "./dialog_peizhiEdit.vue?vue&type=script&lang=js&"
export * from "./dialog_peizhiEdit.vue?vue&type=script&lang=js&"
import style0 from "./dialog_peizhiEdit.vue?vue&type=style&index=0&id=9f66e1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f66e1a6",
  null
  
)

export default component.exports